import { Icon } from '@chakra-ui/react';

const CustomWarningIcon = (props) => {
  return (
    <Icon viewBox="0 0 22 21" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.3991 10.5C21.3991 13.2848 20.2718 15.9555 18.2653 17.9246C16.2587 19.8938 13.5373 21 10.6996 21C7.86186 21 5.14039 19.8938 3.13383 17.9246C1.12727 15.9555 0 13.2848 0 10.5C0 7.71523 1.12727 5.04451 3.13383 3.07538C5.14039 1.10625 7.86186 0 10.6996 0C13.5373 0 16.2587 1.10625 18.2653 3.07538C20.2718 5.04451 21.3991 7.71523 21.3991 10.5ZM12.037 15.75C12.037 16.0981 11.8961 16.4319 11.6453 16.6781C11.3945 16.9242 11.0543 17.0625 10.6996 17.0625C10.3448 17.0625 10.0047 16.9242 9.75384 16.6781C9.50302 16.4319 9.36211 16.0981 9.36211 15.75C9.36211 15.4019 9.50302 15.0681 9.75384 14.8219C10.0047 14.5758 10.3448 14.4375 10.6996 14.4375C11.0543 14.4375 11.3945 14.5758 11.6453 14.8219C11.8961 15.0681 12.037 15.4019 12.037 15.75ZM10.6996 3.9375C10.3448 3.9375 10.0047 4.07578 9.75384 4.32192C9.50302 4.56806 9.36211 4.9019 9.36211 5.25V10.5C9.36211 10.8481 9.50302 11.1819 9.75384 11.4281C10.0047 11.6742 10.3448 11.8125 10.6996 11.8125C11.0543 11.8125 11.3945 11.6742 11.6453 11.4281C11.8961 11.1819 12.037 10.8481 12.037 10.5V5.25C12.037 4.9019 11.8961 4.56806 11.6453 4.32192C11.3945 4.07578 11.0543 3.9375 10.6996 3.9375Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default CustomWarningIcon;
